const styles = [
  {
    "featureType": "all",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#272829"
    }]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#AC977D"
    }]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#E0344A"
    }, {
      "lightness": 14
    }, {
      "weight": 2
    }]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [{
      "color": "#ffffff"
    }]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [{
      "color": "#73b782"
    }, {
      "lightness": 5
    }]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#BABABA"
    }]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#E0344A"
    }, {
      "lightness": 25
    }]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#BABABA"
    }]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#E0344A"
    }, {
      "lightness": 16
    }]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [{
      "color": "#BABABA"
    }]
  },
  {
    "featureType": "transit",
    "elementType": "all",
    "stylers": [{
      "color": "#E0344A"
    }]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{
      "color": "#C8D7D4"
    }]
  }
]

export default styles;



// WEBPACK FOOTER //
// ./src/utils/mapStyles.js